import React                      from 'react'
import { Layout }                 from 'antd'

import { MasteringList }         from './03_screen_key_mastering_list'
import { PseudoTasks }            from './05_screen_key_mastering_pseudo_tasks'


export const KeyMasteringScreen: React.FC = () => {
  return (
  <Layout className="layout">
    <MasteringList />
    <PseudoTasks />
  </Layout>
  );
}
